
import { DropdownItem } from "@/types/dropdown";
import { RECIPE_DROPDOWN_TYPE } from "@/types/recipes";
import SearchDropdownButtonItem from "@/components/search/SearchDropdownButtonItem.vue";
import { defineComponent, SetupContext, ref, PropType } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "RecipeDropdownList",
  components: { SearchDropdownButtonItem },
  props: {
    /**
     * ドロップダウンリスト
     */
    dropdownList: {
      type: Array as PropType<DropdownItem[]>,
      required: true
    },
    selectType: {
      type: String,
      default: "",
      required: true
    },
    type: {
      type: String
    }
  },
  setup(props, context: SetupContext) {
    /**
     * 選択されたタグを通知する
     */
    const selectItem = (label: string) => {
      let type = "";
      props.dropdownList.forEach(e => {
        if (e.label == label) {
          type = e.type;
        }
      });
      context.emit("select-item", type);
    };

    /**
     * ソート名を取得する
     */
    const getSelectLabel = () => {
      let label = "";
      props.dropdownList.forEach(e => {
        if (e.type == props.selectType) {
          label = e.label;
        }
      });
      return label;
    };

    const getTypeIcon = () => {
      let icon = null;
      if (props.type == RECIPE_DROPDOWN_TYPE.THEME) {
        icon = require("@/assets/images/recipe-icon01.png");
      } else if (props.type == RECIPE_DROPDOWN_TYPE.VARIATION) {
        icon = require("@/assets/images/recipe-icon02.png");
      }
      return icon;
    };

    return {
      selectItem,
      getSelectLabel,
      getTypeIcon
    };
  }
});
